import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateSectorsSettings as updateSectorsSettingsRequest } from '@api/sectors';

import { ICreateSectorsSettingsDTO } from '@interfaces/map/dto/sectorsDTO';

import { ESnackbarTypes } from '@enums/common';

import { ALL_SECTORS, SECTOR_SETS, UPDATE_SECTORS_SETTINGS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateEditSectorsSettings = (id: string, onSuccessCallback: () => void): {
	updateSectorsSettings: (data: ICreateSectorsSettingsDTO) => void;
	isUpdatingSectorSettings: boolean;
} => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: updateSectorsSettings,
		isLoading,
	} = useMutation<ICreateSectorsSettingsDTO>({
		mutationKey: [UPDATE_SECTORS_SETTINGS],
		mutationFn: (data: ICreateSectorsSettingsDTO) => updateSectorsSettingsRequest(id, data),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updatedSectorsSettings,
				type: ESnackbarTypes.success,
			}));

			onSuccessCallback();

			return [
				queryClient.invalidateQueries([SECTOR_SETS]),
				queryClient.invalidateQueries([ALL_SECTORS]),
			];
		},
	});

	return {
		updateSectorsSettings,
		isUpdatingSectorSettings: isLoading,
	};
};
